var map = {
	"./LNF/123/0.png": 17698,
	"./LNF/123/1.png": 28073,
	"./LNF/123/2.png": 70430,
	"./LNF/123/3.png": 15133,
	"./LNF/123/4.png": 28617,
	"./LNF/123/5.png": 48477,
	"./LNF/123/6.png": 96424,
	"./LNF/123/7.png": 25991,
	"./LNF/123/8.png": 85886,
	"./LNF/123/9.png": 25100,
	"./LNF/Cursive CAPITALS/A.png": 82102,
	"./LNF/Cursive CAPITALS/B.png": 16812,
	"./LNF/Cursive CAPITALS/C.png": 90083,
	"./LNF/Cursive CAPITALS/D.png": 26595,
	"./LNF/Cursive CAPITALS/E.png": 41619,
	"./LNF/Cursive CAPITALS/F.png": 27927,
	"./LNF/Cursive CAPITALS/G.png": 61954,
	"./LNF/Cursive CAPITALS/H.png": 54895,
	"./LNF/Cursive CAPITALS/I.png": 64911,
	"./LNF/Cursive CAPITALS/J.png": 27212,
	"./LNF/Cursive CAPITALS/K.png": 84265,
	"./LNF/Cursive CAPITALS/L.png": 73950,
	"./LNF/Cursive CAPITALS/M.png": 42846,
	"./LNF/Cursive CAPITALS/N.png": 4298,
	"./LNF/Cursive CAPITALS/O.png": 62657,
	"./LNF/Cursive CAPITALS/P.png": 58115,
	"./LNF/Cursive CAPITALS/Q.png": 39,
	"./LNF/Cursive CAPITALS/R.png": 70474,
	"./LNF/Cursive CAPITALS/S.png": 36631,
	"./LNF/Cursive CAPITALS/T.png": 63228,
	"./LNF/Cursive CAPITALS/U.png": 29971,
	"./LNF/Cursive CAPITALS/V.png": 22364,
	"./LNF/Cursive CAPITALS/W.png": 16816,
	"./LNF/Cursive CAPITALS/X.png": 44510,
	"./LNF/Cursive CAPITALS/Y.png": 38332,
	"./LNF/Cursive CAPITALS/Z.png": 3782,
	"./LNF/Cursive CAPITALS/Ñ.png": 68146,
	"./LNF/Cursive lowercase/a.png": 72055,
	"./LNF/Cursive lowercase/b.png": 34191,
	"./LNF/Cursive lowercase/c.png": 42553,
	"./LNF/Cursive lowercase/d.png": 8873,
	"./LNF/Cursive lowercase/e.png": 36033,
	"./LNF/Cursive lowercase/f.png": 28064,
	"./LNF/Cursive lowercase/g.png": 86063,
	"./LNF/Cursive lowercase/h.png": 61467,
	"./LNF/Cursive lowercase/i.png": 25647,
	"./LNF/Cursive lowercase/j.png": 22895,
	"./LNF/Cursive lowercase/k.png": 76753,
	"./LNF/Cursive lowercase/l.png": 81607,
	"./LNF/Cursive lowercase/m.png": 32386,
	"./LNF/Cursive lowercase/n.png": 97550,
	"./LNF/Cursive lowercase/o.png": 99996,
	"./LNF/Cursive lowercase/p.png": 75771,
	"./LNF/Cursive lowercase/q.png": 89264,
	"./LNF/Cursive lowercase/r.png": 49776,
	"./LNF/Cursive lowercase/s.png": 48407,
	"./LNF/Cursive lowercase/t.png": 72042,
	"./LNF/Cursive lowercase/u.png": 66132,
	"./LNF/Cursive lowercase/v.png": 44934,
	"./LNF/Cursive lowercase/w.png": 90143,
	"./LNF/Cursive lowercase/x.png": 46613,
	"./LNF/Cursive lowercase/y.png": 68705,
	"./LNF/Cursive lowercase/z.png": 29952,
	"./LNF/Cursive lowercase/ñ.png": 61891,
	"./LNF/Print CAPITALS/A.png": 20410,
	"./LNF/Print CAPITALS/B.png": 83180,
	"./LNF/Print CAPITALS/C.png": 73550,
	"./LNF/Print CAPITALS/D.png": 39412,
	"./LNF/Print CAPITALS/E.png": 72702,
	"./LNF/Print CAPITALS/F.png": 88184,
	"./LNF/Print CAPITALS/G.png": 29478,
	"./LNF/Print CAPITALS/H.png": 20908,
	"./LNF/Print CAPITALS/I.png": 53692,
	"./LNF/Print CAPITALS/J.png": 97795,
	"./LNF/Print CAPITALS/K.png": 28526,
	"./LNF/Print CAPITALS/L.png": 75589,
	"./LNF/Print CAPITALS/M.png": 91070,
	"./LNF/Print CAPITALS/N.png": 88864,
	"./LNF/Print CAPITALS/O.png": 60084,
	"./LNF/Print CAPITALS/P.png": 98563,
	"./LNF/Print CAPITALS/Q.png": 73488,
	"./LNF/Print CAPITALS/R.png": 23885,
	"./LNF/Print CAPITALS/S.png": 33176,
	"./LNF/Print CAPITALS/T.png": 75834,
	"./LNF/Print CAPITALS/U.png": 74144,
	"./LNF/Print CAPITALS/V.png": 43209,
	"./LNF/Print CAPITALS/W.png": 59951,
	"./LNF/Print CAPITALS/X.png": 32655,
	"./LNF/Print CAPITALS/Y.png": 98218,
	"./LNF/Print CAPITALS/Z.png": 57840,
	"./LNF/Print CAPITALS/Ñ.png": 57329,
	"./LNF/Print lowercase/a.png": 14462,
	"./LNF/Print lowercase/b.png": 78177,
	"./LNF/Print lowercase/c.png": 28273,
	"./LNF/Print lowercase/d.png": 38666,
	"./LNF/Print lowercase/e.png": 43171,
	"./LNF/Print lowercase/f.png": 22689,
	"./LNF/Print lowercase/g.png": 43401,
	"./LNF/Print lowercase/h.png": 82872,
	"./LNF/Print lowercase/i.png": 93385,
	"./LNF/Print lowercase/j.png": 10254,
	"./LNF/Print lowercase/k.png": 75180,
	"./LNF/Print lowercase/l.png": 39851,
	"./LNF/Print lowercase/m.png": 42178,
	"./LNF/Print lowercase/n.png": 28328,
	"./LNF/Print lowercase/o.png": 60713,
	"./LNF/Print lowercase/p.png": 95555,
	"./LNF/Print lowercase/q.png": 63714,
	"./LNF/Print lowercase/r.png": 19929,
	"./LNF/Print lowercase/s.png": 80096,
	"./LNF/Print lowercase/t.png": 97727,
	"./LNF/Print lowercase/u.png": 14182,
	"./LNF/Print lowercase/v.png": 51222,
	"./LNF/Print lowercase/w.png": 12871,
	"./LNF/Print lowercase/x.png": 90477,
	"./LNF/Print lowercase/y.png": 39206,
	"./LNF/Print lowercase/z.png": 76642,
	"./LNF/Print lowercase/ñ.png": 15619,
	"./WDT/123/0.png": 70206,
	"./WDT/123/1.png": 75625,
	"./WDT/123/2.png": 90646,
	"./WDT/123/3.png": 61060,
	"./WDT/123/4.png": 79413,
	"./WDT/123/5.png": 96712,
	"./WDT/123/6.png": 4514,
	"./WDT/123/7.png": 52765,
	"./WDT/123/8.png": 57272,
	"./WDT/123/9.png": 12602,
	"./WDT/Cursive CAPITALS/A.png": 92845,
	"./WDT/Cursive CAPITALS/B.png": 59874,
	"./WDT/Cursive CAPITALS/C.png": 35626,
	"./WDT/Cursive CAPITALS/D.png": 6598,
	"./WDT/Cursive CAPITALS/E.png": 6422,
	"./WDT/Cursive CAPITALS/F.png": 28657,
	"./WDT/Cursive CAPITALS/G.png": 44250,
	"./WDT/Cursive CAPITALS/H.png": 14205,
	"./WDT/Cursive CAPITALS/I.png": 72484,
	"./WDT/Cursive CAPITALS/J.png": 86604,
	"./WDT/Cursive CAPITALS/K.png": 56956,
	"./WDT/Cursive CAPITALS/L.png": 31326,
	"./WDT/Cursive CAPITALS/M.png": 26122,
	"./WDT/Cursive CAPITALS/N.png": 39064,
	"./WDT/Cursive CAPITALS/O.png": 62114,
	"./WDT/Cursive CAPITALS/P.png": 64114,
	"./WDT/Cursive CAPITALS/Q.png": 8800,
	"./WDT/Cursive CAPITALS/R.png": 36760,
	"./WDT/Cursive CAPITALS/S.png": 14044,
	"./WDT/Cursive CAPITALS/T.png": 82179,
	"./WDT/Cursive CAPITALS/U.png": 51428,
	"./WDT/Cursive CAPITALS/V.png": 61048,
	"./WDT/Cursive CAPITALS/W.png": 41165,
	"./WDT/Cursive CAPITALS/X.png": 38555,
	"./WDT/Cursive CAPITALS/Y.png": 85737,
	"./WDT/Cursive CAPITALS/Z.png": 44751,
	"./WDT/Cursive Connections/ad.png": 50015,
	"./WDT/Cursive Connections/bo.png": 19693,
	"./WDT/Cursive Connections/by.png": 41337,
	"./WDT/Cursive Connections/cc.png": 20088,
	"./WDT/Cursive Connections/ch.png": 63647,
	"./WDT/Cursive Connections/ed.png": 32702,
	"./WDT/Cursive Connections/el.png": 51466,
	"./WDT/Cursive Connections/gl.png": 47541,
	"./WDT/Cursive Connections/it.png": 54307,
	"./WDT/Cursive Connections/oa.png": 6028,
	"./WDT/Cursive Connections/oe.png": 5714,
	"./WDT/Cursive Connections/of.png": 45308,
	"./WDT/Cursive Connections/oi.png": 32549,
	"./WDT/Cursive Connections/on.png": 61604,
	"./WDT/Cursive Connections/or.png": 9470,
	"./WDT/Cursive Connections/os.png": 81466,
	"./WDT/Cursive Connections/pa.png": 1362,
	"./WDT/Cursive Connections/tr.png": 8185,
	"./WDT/Cursive Connections/us.png": 73435,
	"./WDT/Cursive Connections/ve.png": 86723,
	"./WDT/Cursive Connections/wa.png": 73400,
	"./WDT/Cursive Connections/wh.png": 5289,
	"./WDT/Cursive Connections/wi.png": 43192,
	"./WDT/Cursive Connections/yo.png": 66005,
	"./WDT/Cursive lowercase/a.png": 95289,
	"./WDT/Cursive lowercase/b.png": 80389,
	"./WDT/Cursive lowercase/c.png": 57555,
	"./WDT/Cursive lowercase/d.png": 6089,
	"./WDT/Cursive lowercase/e.png": 5000,
	"./WDT/Cursive lowercase/f.png": 96223,
	"./WDT/Cursive lowercase/g.png": 31501,
	"./WDT/Cursive lowercase/h.png": 89299,
	"./WDT/Cursive lowercase/i.png": 66389,
	"./WDT/Cursive lowercase/j.png": 92956,
	"./WDT/Cursive lowercase/k.png": 30303,
	"./WDT/Cursive lowercase/l.png": 31617,
	"./WDT/Cursive lowercase/m.png": 72036,
	"./WDT/Cursive lowercase/n.png": 37977,
	"./WDT/Cursive lowercase/o.png": 93660,
	"./WDT/Cursive lowercase/p.png": 16156,
	"./WDT/Cursive lowercase/q.png": 29592,
	"./WDT/Cursive lowercase/r.png": 95639,
	"./WDT/Cursive lowercase/s.png": 39065,
	"./WDT/Cursive lowercase/t.png": 3494,
	"./WDT/Cursive lowercase/u.png": 80541,
	"./WDT/Cursive lowercase/v.png": 2855,
	"./WDT/Cursive lowercase/w.png": 93432,
	"./WDT/Cursive lowercase/x.png": 25280,
	"./WDT/Cursive lowercase/y.png": 88235,
	"./WDT/Cursive lowercase/z.png": 34343,
	"./WDT/Print CAPITALS/A.png": 27476,
	"./WDT/Print CAPITALS/B.png": 85353,
	"./WDT/Print CAPITALS/C.png": 34074,
	"./WDT/Print CAPITALS/D.png": 70457,
	"./WDT/Print CAPITALS/E.png": 60118,
	"./WDT/Print CAPITALS/F.png": 51860,
	"./WDT/Print CAPITALS/G.png": 53860,
	"./WDT/Print CAPITALS/H.png": 58341,
	"./WDT/Print CAPITALS/I.png": 62950,
	"./WDT/Print CAPITALS/J.png": 3283,
	"./WDT/Print CAPITALS/K.png": 6961,
	"./WDT/Print CAPITALS/L.png": 96369,
	"./WDT/Print CAPITALS/M.png": 76501,
	"./WDT/Print CAPITALS/N.png": 42690,
	"./WDT/Print CAPITALS/O.png": 97304,
	"./WDT/Print CAPITALS/P.png": 92485,
	"./WDT/Print CAPITALS/Q.png": 54248,
	"./WDT/Print CAPITALS/R.png": 93790,
	"./WDT/Print CAPITALS/S.png": 34209,
	"./WDT/Print CAPITALS/T.png": 43322,
	"./WDT/Print CAPITALS/U.png": 52308,
	"./WDT/Print CAPITALS/V.png": 80138,
	"./WDT/Print CAPITALS/W.png": 56469,
	"./WDT/Print CAPITALS/X.png": 97242,
	"./WDT/Print CAPITALS/Y.png": 5216,
	"./WDT/Print CAPITALS/Z.png": 4181,
	"./WDT/Print lowercase/a.png": 85952,
	"./WDT/Print lowercase/b.png": 75594,
	"./WDT/Print lowercase/c.png": 43121,
	"./WDT/Print lowercase/d.png": 72967,
	"./WDT/Print lowercase/e.png": 11674,
	"./WDT/Print lowercase/f.png": 50537,
	"./WDT/Print lowercase/g.png": 26891,
	"./WDT/Print lowercase/h.png": 23615,
	"./WDT/Print lowercase/i.png": 81015,
	"./WDT/Print lowercase/j.png": 73978,
	"./WDT/Print lowercase/k.png": 61024,
	"./WDT/Print lowercase/l.png": 98850,
	"./WDT/Print lowercase/m.png": 92682,
	"./WDT/Print lowercase/n.png": 95765,
	"./WDT/Print lowercase/o.png": 40484,
	"./WDT/Print lowercase/p.png": 99134,
	"./WDT/Print lowercase/q.png": 46966,
	"./WDT/Print lowercase/r.png": 49665,
	"./WDT/Print lowercase/s.png": 19553,
	"./WDT/Print lowercase/t.png": 1934,
	"./WDT/Print lowercase/u.png": 98246,
	"./WDT/Print lowercase/v.png": 26676,
	"./WDT/Print lowercase/w.png": 15991,
	"./WDT/Print lowercase/x.png": 51255,
	"./WDT/Print lowercase/y.png": 6421,
	"./WDT/Print lowercase/z.png": 60448,
	"./WoodPieces/Capitals/A.png": 81243,
	"./WoodPieces/Capitals/B.png": 40696,
	"./WoodPieces/Capitals/C.png": 24332,
	"./WoodPieces/Capitals/D.png": 99738,
	"./WoodPieces/Capitals/E.png": 77740,
	"./WoodPieces/Capitals/F.png": 14542,
	"./WoodPieces/Capitals/G.png": 44826,
	"./WoodPieces/Capitals/H.png": 82205,
	"./WoodPieces/Capitals/I.png": 38539,
	"./WoodPieces/Capitals/K.png": 29423,
	"./WoodPieces/Capitals/L.png": 43673,
	"./WoodPieces/Capitals/M.png": 91716,
	"./WoodPieces/Capitals/N.png": 68605,
	"./WoodPieces/Capitals/O.png": 71044,
	"./WoodPieces/Capitals/P.png": 24292,
	"./WoodPieces/Capitals/Q.png": 68521,
	"./WoodPieces/Capitals/R.png": 20281,
	"./WoodPieces/Capitals/S.png": 2457,
	"./WoodPieces/Capitals/T.png": 36546,
	"./WoodPieces/Capitals/V.png": 72421,
	"./WoodPieces/Capitals/W.png": 78012,
	"./WoodPieces/Capitals/X.png": 22411,
	"./WoodPieces/Capitals/Y.png": 71029,
	"./WoodPieces/Capitals/Z.png": 23059
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83695;